// extracted by mini-css-extract-plugin
var _1 = "EmailCreateButton-modulemobileSize__UNRtN";
export { _1 as "mobileSize" }
